import { render, staticRenderFns } from "./RoomImage.vue?vue&type=template&id=20f86a67&scoped=true"
import script from "./RoomImage.vue?vue&type=script&lang=ts"
export * from "./RoomImage.vue?vue&type=script&lang=ts"
import style0 from "./RoomImage.vue?vue&type=style&index=0&id=20f86a67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f86a67",
  null
  
)

export default component.exports